import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-camera-page" }
const _hoisted_2 = { class: "pantry-camera-page-image-area" }
const _hoisted_3 = { class: "pantry-camera-page-image-view" }
const _hoisted_4 = { class: "pantry-image-view-room-select" }
const _hoisted_5 = { class: "pantry-camera-page-camera-date-dialog-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryImageView = _resolveComponent("PantryImageView")
  const _component_PantryImageSelectView = _resolveComponent("PantryImageSelectView")
  const _component_PantryCameraDateDialog = _resolveComponent("PantryCameraDateDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_PantryImageView, {
          key: _ctx.updateDisplayKey,
          rooms: _ctx.fridgeImageList,
          selectRoomId: _ctx.selectRoomId,
          cameraRoomInfo: _ctx.cameraRoomInfo,
          applianceId: _ctx.applianceId,
          imageUpdate: _ctx.updateListKey,
          onClickClose: _ctx.onClickCloseCamera,
          onSelectRoom: _ctx.onSelectRoom,
          onSelectImage: _ctx.onSelectImage,
          onShowDate: _ctx.onShowDate
        }, null, 8, ["rooms", "selectRoomId", "cameraRoomInfo", "applianceId", "imageUpdate", "onClickClose", "onSelectRoom", "onSelectImage", "onShowDate"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_PantryImageSelectView, {
          selectRoomId: _ctx.selectRoomId,
          onSelectRoom: _ctx.onSelectRoom
        }, null, 8, ["selectRoomId", "onSelectRoom"])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _createVNode(_component_PantryCameraDateDialog, {
        key: _ctx.updateDateDialogKey,
        roomId: _ctx.dateRoomId,
        areaId: _ctx.dateAreaId,
        selectId: _ctx.dateSelectId,
        dateList: _ctx.dateList,
        onSelectDate: _ctx.onSelectDate
      }, null, 8, ["roomId", "areaId", "selectId", "dateList", "onSelectDate"])
    ], 512), [
      [_vShow, _ctx.isShowCameraDateDialog]
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}